import React from "react";
import { appendVirtualEventForm } from "venuescanner-js/vanilla/forms/VirtualEventEnquiryForm/VirtualEventEnquiryForm";

const Form = (props) => {
  const { setIsFormOpen } = props;

  return (
    <div className={`virtual-events-form`}>
      <div className="virtual-events-form__wrapper">
        <span
          className="virtual-events-form__close"
          onClick={() => setIsFormOpen(false)}
        />
        <h3>Virtual Event Enquiry</h3>
        <div ref={(el) => appendVirtualEventForm(el, setIsFormOpen)} />
      </div>
    </div>
  );
};

export default Form;
